<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/medical/topic_icon.svg" />
      <h1>Medical Facilities</h1>
      <p>
        Ensure the health of patients and staff is protected from
        <br />
        viruses and bacteria.
      </p>
      <div class="topic-tags">
        <span class="tag"> #General Hospitals </span>
        <span class="tag"> #Hospitals </span>
        <span class="tag"> #Postnatal Care Centers </span>
        <span class="tag"> #Nursing Hospitals </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img
      :src="require(`@/assets/images/location/medical/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [BusinessSectors] Medical Facilities"
    />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_speaker.svg" alt="CESCO [BusinessSectors] Medical Facilities" />
            <div class="title">
              <h3>Differentiated Marketing Strategy</h3>
            </div>
            <p class="description">I want to introduce the hospital as a place that manages hygiene systematically and maintains cleanliness.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_pests.svg" alt="CESCO [BusinessSectors] Medical Facilities" />
            <div class="title">
              <h3>Custom Pest Control for Each Space</h3>
            </div>
            <p class="description">I am concerned about pests frequently occurring in each space, from bed mites to cockroaches and fruit flies.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_prevent.svg" alt="CESCO [BusinessSectors] Medical Facilities" />
            <div class="title">
              <h3>Professional Disinfection</h3>
            </div>
            <p class="description">I am worried about the proliferation of viruses and bacteria in spaces touched and breathed on by patients.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>
              Introduce our medical facilities as spaces secured against various hazards.
              <br />
              <br />
            </h4>
            <p>
              In hospitals, where infectious viruses and bacteria can easily spread, we provide specialized solutions for continuous management,
              meticulous pest control, and food safety.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/medical/border_content_01.png" alt="CESCO [BusinessSectors] Medical Facilities" />
          </div>
          <div>
            <img src="@/assets/images/location/medical/border_content_02.png" alt="CESCO [BusinessSectors] Medical Facilities" />
          </div>
          <div class="border-content">
            <h4>
              Enhance patient rooms and consultation areas with pest control tailored to each specific environment to maintain a comfortable facility.
            </h4>
            <p>
              We identify and effectively resolve issues with pests ranging from dust mites in patient beds to flying insects in medication storage
              areas, offering precise solutions for each space in medical facilities.
            </p>
          </div>
          <div class="border-content">
            <h4>For the safety of our patients, we manage harmful elements using the safest chemicals and proven equipment.</h4>
            <p>
              Focusing on the health of immunocompromised patients, we manage with optimal safety and hygiene. We used disinfectants less toxic than
              salt, and employ equipment certified by professional institutions
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/medical/border_content_03.png" alt="CESCO [BusinessSectors] Medical Facilities" />
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="CESCO [BusinessSectors] Medical Facilities" />

          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="CESCO [BusinessSectors] Medical Facilities" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Medical Facilities
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="CESCO [BusinessSectors] Medical Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="CESCO [BusinessSectors] Medical Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_air.svg" alt="CESCO [BusinessSectors] Medical Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Air Quality
                  <br />
                  Assurance
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">This solution manages everything from ultrafine particles to radon radiation to ensure safety.</p>
            </div>

            <router-link to="/solution/service/air"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/medical/background_img_01.png'),
    products: [
      {
        posX: '18.3125rem',
        posY: '7.7162rem',
        mobilePosX: '25%',
        mobilePosY: '25%',
        productInfo: {
          image: require('@/assets/images/location/medical/product_img_01.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'Destroys viruses directly in the air with the Virus Pre-attack System<sup>TM</sup>. *Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/medical/background_img_02.png'),
    products: [
      {
        posX: '33.125rem',
        posY: '5.2162rem',
        mobilePosX: '44%',
        mobilePosY: '19%',
        productInfo: {
          image: require('@/assets/images/location/medical/product_img_02.png'),
          name: 'CESCO\nIndoor Insect Light Inceptor',
          description: 'This device controls stray pests entering business premises and also serves an aesthetic function with its compact design.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/medical/background_img_03.png'),
    products: [
      {
        posX: '42.1875rem',
        posY: '18.7787rem',
        mobilePosX: '56%',
        mobilePosY: '50%',
        productInfo: {
          image: require('@/assets/images/location/medical/product_img_04.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/medical/background_img_04.png'),
    products: [
      {
        posX: '58.25rem',
        posY: '23.2787rem',
        mobilePosX: '76.5%',
        mobilePosY: '63%',
        productInfo: {
          image: require('@/assets/images/location/medical/product_img_05.png'),
          name: 'CESCO\nWater Smart-Fit Direct Water Purifier',
          description: 'Enhance your kitchen with a water purifier available in eight colors tailored to your personal taste.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/medical/background_img_05.png'),
    products: [
      {
        posX: '19.0625rem',
        posY: '6.9662rem',
        mobilePosX: '23%',
        mobilePosY: '30%',
        productInfo: {
          image: require('@/assets/images/location/medical/product_img_06.png'),
          name: 'CESCO\nSpace Fragrancer Airperfume',
          description: 'This product uniformly scents large spaces with fragrances designed specifically for various types of businesses.'
        }
      }
    ]
  },

  {
    backgroundImg: require('@/assets/images/location/medical/background_img_06.png'),
    products: [
      {
        posX: '42.5625rem',
        posY: '8.2163rem',
        mobilePosX: '56%',
        mobilePosY: '25%',
        productInfo: {
          image: require('@/assets/images/location/medical/product_img_07.png'),
          name: 'CESCO\nIndoor Insect Light Inceptor',
          description: 'This device controls stray pests entering business premises and also serves an aesthetic function with its compact design.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/medical/background_img_07.png'),
    products: [
      {
        posX: '16.25rem',
        posY: '10.5288rem',
        mobilePosX: '23%',
        mobilePosY: '30%',
        productInfo: {
          image: require('@/assets/images/location/medical/product_img_01.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'Destroys viruses directly in the air with the Virus Pre-attack System<sup>TM</sup>. *Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/medical/background_img_08.png'),
    products: [
      {
        posX: '13.25rem',
        posY: '28.5912rem',
        mobilePosX: '18%',
        mobilePosY: '80%',
        productInfo: {
          image: require('@/assets/images/location/medical/product_img_08.png'),
          name: 'CESCO\nAir Radon RoomCare Air Purifier SE',
          description: 'Continuously manages harmful substances such as ultrafine dust, radon, and CO2 in living rooms and bedrooms.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/medical/background_img_09.png'),
    products: [
      {
        posX: '57.25rem',
        posY: '17.5287rem',
        mobilePosX: '75%',
        mobilePosY: '50%',
        productInfo: {
          image: require('@/assets/images/location/medical/product_img_09.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/medical/background_img_10.png'),
    products: [
      {
        posX: '20.8125rem',
        posY: '10.5288rem',
        mobilePosX: '28%',
        mobilePosY: '30%',
        productInfo: {
          image: require('@/assets/images/location/medical/product_img_10.png'),
          name: 'CESCO\nAirgenic',
          description: 'This automatic air freshener and deodorizer boasts powerful odor neutralization and fragrance release.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}

useMeta({
  title: 'CESCO - Medical Facilities',
  meta: [
    {
      name: 'description',
      content: 'Medical Facilities. Ensure the health of patients and staff is protected from viruses and bacteria.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
